import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconClapboard"><Path d="M21 18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V9H21V18.5Z" fill="currentColor"/><Path d="M6.92969 8H3V5.5C3 4.11929 4.11929 3 5.5 3H9.22168L6.92969 8Z" fill="currentColor"/><Path d="M13.4297 8H8.02832L10.3203 3H15.7217L13.4297 8Z" fill="currentColor"/><Path d="M18.5 3C19.8807 3 21 4.11929 21 5.5V8H14.5283L16.8203 3H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClapboard;
